/// <reference types="vite/client" />
import '../scss/app.scss';

import axios, { AxiosInstance } from 'axios';

declare global {
  interface Window {
    axios: AxiosInstance;
  }
}

window.axios = axios.create({
  baseURL: import.meta.env.VITE_APP_URL,
});
window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
window.axios.defaults.withCredentials = true;
window.axios.defaults.withXSRFToken = true;

import './appRoot';
